<template>
    <div :class="['insertionOpt']">
        <!--<div class="attachedLogo White"></div>-->
        <div class="sectionTitle black">
            <splitter :content="localize(sectionData.title)"></splitter>
        </div>        
        <div class="insContainer">

            <!-- Images Container -->
            <div class="insScroller" ref="scrollerRef" id="scroller1">
                <ul class="insImages">
                    <li class="insItem" v-for="(item, index) in sectionData.items" :key="index">
                        <img v-bind:src="item.img" />
                    </li>
                </ul>
            </div>

            <!-- Navigation Container 
            <ul class="insNav">
                <li v-for="(item, index) in sectionData.items" :key="index" @click="navTo(index)">
                    <div :class="['insPagerBtn',index ==  selectedIndex ? 'selected' : '']">
                        <div :style="getStyleIndex(index)">{{item.num}}</div>
                        <div :style="getStyleIndex(index)">{{item.title}}</div>
                    </div>
                </li>          
            </ul>-->

            <ul class="insNav2">
                <li v-for="(item, index) in sectionData.items" :key="index" @click="navTo(index)">
                    <div :class="['insPagerBtn2',index ==  selectedIndex ? 'selected' : '']">
                        <img v-bind:src="item.icon" />
                        <div class="iconTitle" :style="getStyleIndex(index)">{{localize(item.title)}}</div>
                    </div>
                </li>          
            </ul>

        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import splitter from "@/views/com/splitter.vue";

export default {
    name: "InsertionOptions",
    components:{splitter},
    props: {
        isNavOpen: Boolean
    },
    data()
    {
        return {
            selectedIndex:0
        }
    },
    mounted() {
        this.initScrollListener();
    },
    destroyed() {
        this.removeScrollListener();
    },
    methods:
    {
        initScrollListener() {
            var vm = this;
            let scroller = this.$refs.scrollerRef;
            scroller.addEventListener("scroll", vm.checkScrollPosition, false);
        },
        removeScrollListener() {
            var vm = this;
            let scroller = this.$refs.scrollerRef;
            scroller.removeEventListener("scroll", vm.checkScrollPosition);
        },

        checkScrollPosition() {
            var vm=this;
            let scroller = this.$refs.scrollerRef;
            let scrX = scroller.offsetLeft;
            let scrolledX = scroller.scrollLeft;
            var reveals = scroller.querySelectorAll(".insItem");
            for (var i = 0; i < reveals.length; i++) {
                //find the element to highligt 
                //remove the scroller offset from the 
                if((scrolledX+scrX)==reveals[i].offsetLeft){
                    vm.selectedIndex = i;
                }
                console.log("scrX="+scrX+"  scrolledX:"+ scrolledX+" element:"+i+" left:"+reveals[i].offsetLeft);
            }
        },

        navTo(index)
        {
            //only on mobile !
            //alert("goto slide "+index);            
            //this.$refs.scrollerRef.scrollLeft(100);
            this.selectedIndex = index;
            
            let scrollToElement = this.$refs.scrollerRef.getElementsByClassName("insItem")[index];
            scrollToElement.scrollIntoView(
                { 
                    behavior: 'smooth',
                    inline:'center',
                    block:'nearest' }
            );            
            //var elmnt = this.$refs.scrollerRef;//document.getElementById("scroller1");
            //let sl = elmnt.scrollLeft;
            //alert("sl="+sl);
            //elmnt.scrollLeft += 50;
        },
      onIndexChange(imgIndex)
      {
        //this.plaformIndex = plaformIndex;
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["siteData","siteDataReady"]),
        sectionData(){
            return this.siteData.SECTIONS[7];
            /*
            Data sample:
            {
                "comment":"///////////////////////// Insertion Options /////////////////////////", 
                "section":"insertion_options",
                "title":"Insertion Options",
                "items":[
                    {"title":"Manual", "num":"1",  "img":"img/lance/insertion/ins_opt_manual.png"},
                    {"title":"Motor",  "num":"2", "img":"img/lance/insertion/ins_opt_motor.png"},
                    {"title":"Rachet", "num":"3", "img":"img/lance/insertion/ins_opt_rachet.png"}
                ]
            },

            */
        }

    }
};

</script>


<style>
    .insertionOpt
    {      
        position:relative;
        width: 100vw;
        height: 100%;
        display: grid;
        align-items: center;
        /* background-color: #ffffff; */
    }    
    .insertionOpt .title
    {
        font-size: 18px !important;
        font-weight: 100 !important;
        font-weight: 400 !important;        
        letter-spacing: -0.5px;
        color: var(--text-blue);
        text-align:left;        
        position:absolute;
        top:0px;left: 0px;
        padding-left: max(180px, 10vw);
        top:100px;        
    }

    .insertionOpt .insContainer
    {
      width: 40vw;margin: auto;
    }
    .insScroller
    {
        overflow-x:scroll;
        overflow-y: hidden;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }    
    .insScroller::-webkit-scrollbar {
        display: none;
    }

    .insImages 
    {
        clear: both;list-style: none;  width: 120vw;  
    }
    .insImages li
    {
        width: 40vw;float: left;text-align: center;
        border:  solid 0px red;
        scroll-snap-align: start;
        scroll-snap-stop: normal;

    }
    .insImages li img
    {
        height: 340px;
        width: auto;
    }

    .insNav 
    {
        clear: both;list-style: none; width: 300px;  
        padding-top: 10px;
        margin: auto;
    }
    .insNav li
    {
        width: 33%;float: left;text-align: center;
    }
    .insNav .insPagerBtn
    {
        width: 120px;margin: auto;padding: 15px 0px;
    }

    .insPagerBtn div:nth-child(1)
    {
        clear: both;
        font-size: 50px;
        font-weight: 400;
        color: var(--text-blue);
        text-align: center;
        width: 50px;
        margin: auto;
        line-height: 45px;
    }    
    .insPagerBtn div:nth-child(2)
    {
        clear: both;
        font-size: 16px;
        font-weight: 500;
        color: var(--text-gray-dark);
        text-align: center;
    }    

    /* selected mode: */ 
    .insNav .insPagerBtn.selected
    {
        background-color: var(--text-blue);
        color:#fff;
    }
    .insNav .insPagerBtn.selected div:nth-child(1),
    .insNav .insPagerBtn.selected div:nth-child(2)
    {
        transition: all ease 0.6s;
        color:#fff !important;
    }    

    /* NAV2 */
    .insNav2
    {
        clear: both;list-style: none; width: 400px;padding-top: 10px;margin: auto;
    }
    .insNav2 li
    {
        width: 33%;float: left;text-align: center;
    }
    .insNav2 .insPagerBtn2
    {
        width: 120px;margin: auto;padding: 15px 0px;
    }    
    .insNav2 .insPagerBtn2 img
    {
        width: 90px;height: 90px;
        background-color: #f2f5f7;
        border-radius: 100px;
        border: solid 1px #cfdde5;
    }    
    .insNav2 .insPagerBtn2 .iconTitle
    {
        font-size: 18px;
        clear: both;
        width: 100%;
        text-align: center;
        padding-top: 5px;
    }    
    .insNav2 .insPagerBtn2.selected img
    {
        background-color:#cfdde5;
    }
    .insNav2 .insPagerBtn2.selected .iconTitle
    {
        font-weight: bold;
    }



  @media (hover: hover) {
    .insNav2 .insPagerBtn2:hover img
    {
        background-color: #cfdde5;
        border: solid 1px #1178be;
        cursor: pointer;
    }

  }




  @media (max-width: 850px) {     
    .insertionOpt
    {      
        height: auto;    
        min-height: inherit;
        padding: 0px 0px 100px 0px;        
    }        
    .insertionOpt .insContainer
    {
      width: 100vw;margin: auto;padding-top: 50px;
    }
    .insImages li img {
        height: 280px;
        width: auto;
    }    

    .insImages{
        width: 300vw;
    }
    .insImages li{
        width: 100vw;
        scroll-snap-align: start;
        scroll-snap-stop: normal;
    }
    .insNav2
    {
        width: 80vw;margin: auto;
    }
    .insNav2 li
    {
        margin: 5px;width: calc(33% - 10px);
    }
    .insNav2 .insPagerBtn2
    {
        width: 100%;margin: auto;padding: 15px 0px 0px 0px;
        transition: all ease 0.6s;
    }




  }  
</style>